import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getJoinNetworkWithTokenKey } from '../../utils/keys';
export const useJoinNetworkWithToken = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const joinNetworkKey = getJoinNetworkWithTokenKey();
    return useMutation((input) => client.auth.joinNetworkWithToken(input, fields), { mutationKey: joinNetworkKey, ...useMutationOptions });
};
//# sourceMappingURL=useJoinNetworkWithToken.js.map